import React from 'react';
import { Container, Row, Col, Card, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import usePricingRules from '../../hooks/usePricingRules';
import colors from '../../constants/colors';

const PrivacyTerms = () => {
    // Portes e limiar de envio grátis vêm da API; se falharem, o texto é mostrado sem valores.
    const pricingRules = usePricingRules();

    const formatAmount = (amount) =>
        typeof amount === 'number' ? amount.toFixed(2).replace('.', ',') : null;

    const shippingCostText = formatAmount(pricingRules?.shippingCost);
    const freeShippingText = formatAmount(pricingRules?.freeShippingThreshold);

    return (
        <Container className="py-5">
            <Breadcrumb className="mb-4">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Termos e Privacidade</Breadcrumb.Item>
            </Breadcrumb>

            <h1 className="mb-4" style={{ color: colors.secondary }}>Termos e Política de Privacidade</h1>
            
            <Row>
                <Col>
                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Introdução</h2>
                            <p>
                                Bem-vindo à nossa Política de Privacidade. A nossa empresa está empenhada em proteger 
                                a tua privacidade e os teus dados pessoais. Este documento explica como recolhemos, 
                                utilizamos e protegemos as tuas informações quando utilizas o nosso site e os nossos serviços.
                            </p>
                            <p>
                                Ao utilizares o nosso website, concordas com os termos descritos nesta política. 
                                Caso não concordes com algum dos termos aqui apresentados, pedimos que não utilizes os nossos serviços.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Recolha de Informações</h2>
                            <p>
                                Recolhemos dados pessoais quando registas uma conta, fazes uma compra, subscreves a nossa 
                                newsletter ou interages com o nosso website. As informações que podemos recolher incluem:
                            </p>
                            <ul>
                                <li>Nome e apelido</li>
                                <li>Endereço de email</li>
                                <li>Endereço postal e de faturação</li>
                                <li>Número de telefone</li>
                                <li>Detalhes de pagamento (processados de forma segura através dos nossos fornecedores de pagamento)</li>
                                <li>Endereço IP e dados de navegação</li>
                                <li>Histórico de compras e preferências</li>
                            </ul>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Utilização da Informação</h2>
                            <p>Utilizamos as tuas informações para:</p>
                            <ul>
                                <li>Processar e entregar as tuas encomendas</li>
                                <li>Gerir a tua conta e fornecer suporte ao cliente</li>
                                <li>Enviar comunicações sobre os teus pedidos ou conta</li>
                                <li>Enviar, com o teu consentimento, newsletters e comunicações de marketing</li>
                                <li>Melhorar os nossos produtos e serviços</li>
                                <li>Cumprir as nossas obrigações legais e fiscais</li>
                                <li>Prevenir fraudes</li>
                            </ul>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Cookies e Tecnologias Semelhantes</h2>
                            <p>
                                O nosso website utiliza cookies e tecnologias semelhantes para melhorar a tua experiência 
                                de navegação, analisar como os utilizadores utilizam o nosso site e personalizar conteúdos e anúncios.
                            </p>
                            <p>Os tipos de cookies que utilizamos incluem:</p>
                            <ul>
                                <li>Cookies essenciais: necessários para o funcionamento do website</li>
                                <li>Cookies analíticos: para compreender como os utilizadores interagem com o nosso site</li>
                                <li>Cookies funcionais: para lembrar as tuas preferências e definições</li>
                                <li>Cookies de publicidade: para apresentar anúncios relevantes e medir a sua eficácia</li>
                            </ul>
                            <p>
                                Podes ajustar as tuas preferências de cookies através das definições do teu navegador, 
                                embora isso possa afetar a funcionalidade do nosso website.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Partilha de Informações</h2>
                            <p>
                                Podemos partilhar os teus dados pessoais com terceiros em determinadas circunstâncias:
                            </p>
                            <ul>
                                <li>Fornecedores de serviços que nos ajudam a operar o nosso negócio (processamento de pagamentos, entregas, armazenamento em cloud, etc.)</li>
                                <li>Autoridades fiscais, reguladoras ou outras, quando exigido por lei</li>
                                <li>Potenciais compradores ou investidores, caso a nossa empresa seja vendida ou reestruturada</li>
                            </ul>
                            <p>
                                Asseguramos que todos os terceiros respeitam a segurança dos teus dados pessoais 
                                e os tratam de acordo com a lei.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Os Teus Direitos</h2>
                            <p>Ao abrigo do Regulamento Geral de Proteção de Dados (RGPD), tens os seguintes direitos:</p>
                            <ul>
                                <li>Direito de acesso aos teus dados pessoais</li>
                                <li>Direito de retificação de dados incorretos ou incompletos</li>
                                <li>Direito ao apagamento dos teus dados (direito a ser esquecido)</li>
                                <li>Direito à limitação do tratamento dos teus dados</li>
                                <li>Direito à portabilidade dos dados</li>
                                <li>Direito de oposição ao tratamento dos teus dados</li>
                                <li>Direito de não ficar sujeito a decisões automatizadas, incluindo definição de perfis</li>
                            </ul>
                            <p>
                                Para exerceres estes direitos, contacta-nos através dos detalhes fornecidos na secção "Contacta-nos".
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Segurança de Dados</h2>
                            <p>
                                Implementamos medidas de segurança técnicas e organizacionais adequadas para proteger os 
                                teus dados contra acesso, alteração, divulgação ou destruição não autorizados. 
                                Estas medidas incluem:
                            </p>
                            <ul>
                                <li>Encriptação de dados sensíveis</li>
                                <li>Firewalls e sistemas de deteção de intrusões</li>
                                <li>Acesso restrito a dados pessoais</li>
                                <li>Formação regular dos colaboradores em matéria de segurança de dados</li>
                                <li>Avaliações regulares dos nossos procedimentos de segurança</li>
                            </ul>
                            <p>
                                Apesar das nossas medidas de segurança, nenhuma transmissão de dados pela Internet ou 
                                sistema de armazenamento é 100% seguro. Caso tenhas conhecimento de qualquer falha de segurança, 
                                por favor contacta-nos imediatamente.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Conservação de Dados</h2>
                            <p>
                                Conservamos os teus dados pessoais apenas pelo tempo necessário para cumprir os fins para 
                                os quais foram recolhidos, incluindo para satisfazer requisitos legais, contabilísticos ou de relatórios.
                            </p>
                            <p>
                                Para determinar o período de conservação apropriado, consideramos a quantidade, natureza e 
                                sensibilidade dos dados pessoais, o risco potencial de danos por uso não autorizado ou divulgação, 
                                os fins para os quais os processamos e se podemos alcançar esses fins através de outros meios.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Menores</h2>
                            <p>
                                O nosso website não se destina a menores de 16 anos e não recolhemos intencionalmente 
                                dados de menores. Se tiveres conhecimento de que um menor nos forneceu dados pessoais, 
                                por favor contacta-nos e tomaremos as medidas para remover essa informação dos nossos registos.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Alterações à Política de Privacidade</h2>
                            <p>
                                Podemos atualizar esta política periodicamente em resposta a alterações legais, técnicas 
                                ou comerciais. Quando atualizarmos a nossa política de privacidade, tomaremos as medidas 
                                apropriadas para te informar, de acordo com a importância das alterações efetuadas.
                            </p>
                            <p>
                                Encorajamos-te a rever periodicamente esta política para te manteres informado sobre como 
                                protegemos os teus dados.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Termos e Condições de Envio de Encomendas</h2>
                            <p>Estes Termos e Condições de Envio aplicam-se a todas as encomendas realizadas na nossa loja online. Ao efetuares uma compra, aceitas estas condições.</p>
                            
                            <h5 className="mt-4">1. Processamento das Encomendas</h5>
                            <ul>
                                <li>Todas as encomendas são processadas em dias úteis (de segunda a sexta-feira, exceto feriados).</li>
                                <li>Após a confirmação do pagamento, a encomenda será preparada e enviada num prazo entre 2 até 7 dias úteis.</li>
                                <li>Caso exista algum atraso ou rutura de stock, serás informado por email ou telefone.</li>
                            </ul>

                            <h5 className="mt-4">2. Métodos de Envio</h5>
                            <ul>
                                <li>As encomendas são enviadas através de CTT Expresso.</li>
                                <li>O método de envio e os prazos estimados são apresentados no momento da finalização da compra.</li>
                            </ul>

                            <h5 className="mt-4">3. Prazos de Entrega em Média Previstos</h5>
                            <ul>
                                <li>Entregas em Portugal Continental: 2 dias úteis após o envio.</li>
                                <li>Entregas para as Ilhas (Açores e Madeira) e Internacional: 3 a 15 dias úteis.</li>
                            </ul>
                            <p><strong>Nota:</strong> Estes prazos são estimativas fornecidas pelas transportadoras e podem sofrer alterações por motivos alheios à nossa responsabilidade (ex: greves, condições climatéricas, períodos festivos).</p>

                            <h5 className="mt-4">4. Custos de Envio</h5>
                            <ul>
                                <li>
                                    {shippingCostText
                                        ? `O valor dos portes é de ${shippingCostText}€ por envio, para Portugal Continental.`
                                        : 'Os portes são calculados e apresentados no momento da finalização da compra, para Portugal Continental.'}
                                </li>
                                <li>
                                    {freeShippingText
                                        ? `Envios gratuitos em encomendas acima de ${freeShippingText}€.`
                                        : 'Oferecemos envios gratuitos a partir de um determinado valor de encomenda, indicado no carrinho.'}
                                </li>
                            </ul>

                            <h5 className="mt-4">5. Acompanhamento da Encomenda</h5>
                            <ul>
                                <li>Assim que a encomenda for enviada, ser-te-á enviado um email com o número de rastreamento (tracking number), quando aplicável.</li>
                                <li>É da tua responsabilidade acompanhar a entrega e garantir que alguém está disponível para a receção da encomenda no local indicado.</li>
                            </ul>

                            <h5 className="mt-4">6. Encomendas Devolvidas</h5>
                            <ul>
                                <li>Caso a tua encomenda seja devolvida por morada incorreta/incompleta ou ausência na receção, o reenvio implicará um novo pagamento dos portes.</li>
                                <li>Serás contactado para regularizar a situação.</li>
                            </ul>

                            <h5 className="mt-4">7. Danos ou Itens em Falta</h5>
                            <ul>
                                <li>Se receberes a tua encomenda danificada ou incompleta, entra em contacto connosco no prazo de 48h após a receção, enviando fotografias e a descrição do problema para o nosso email geral@marciamaio.pt</li>
                                <li>Avaliaremos o caso e apresentaremos uma solução (reenvio, devolução ou reembolso parcial, conforme aplicável).</li>
                            </ul>
                            
                            <h5 className="mt-4">8. Contactos</h5>
                            <p>Para qualquer dúvida relacionada com o envio da tua encomenda, podes contactar-nos por:</p>
                            <ul>
                                <li>Email: geral@marciamaio.pt</li>
                                <li>WhatsApp: +351 916 444 093</li>
                                <li>Formulário de contacto disponível no site.</li>
                            </ul>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-3" style={{ color: colors.secondary }}>Contacta-nos</h2>
                            <p>
                                Se tiveres dúvidas sobre esta política de privacidade ou sobre como tratamos os teus dados 
                                pessoais, contacta-nos através de:
                            </p>
                            <ul>
                                <li>Email: geral@marciamaio.pt</li>
                                <li>Telefone: +351 916 444 093</li>
                            </ul>
                            <p>
                                Tens também o direito de apresentar uma reclamação junto da Comissão Nacional de 
                                Proteção de Dados (CNPD), a autoridade de supervisão de proteção de dados em Portugal.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="shadow-sm">
                        <Card.Body>
                            <p className="mb-0 text-center">
                                <small className="text-muted">
                                    Última atualização: {new Date().toLocaleDateString('pt-PT')}
                                </small>
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default PrivacyTerms;